module.exports = __webpack_public_path__ + "fonts/Roboto-RegularItalic.df8e3a9b.woff2";